module.exports = __webpack_public_path__ + "static/Sentencing and Victim Compensation Principles and Practices-69307c2247931c869be2ce17fea64165.jpg";